import React from "react";
import logoPath from "../assets/logo.webp";


const Logo = ({ width = 125, ...props }) => {
  return (
    <img
      src={logoPath} 
      alt="Baseline11"
      width={width}
      {...props}
    />
  );
};

export default Logo;
